// @ts-nocheck
import { StarBorder } from "@mui/icons-material";
import { Rating } from "@mui/material";
import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";
import { getCssVariableHandler } from "../../utils/styles/getCssVariables";
import { Star } from "@mui/icons-material";

const PinkRating = styled(Rating)({
  "& .MuiRating-iconFilled": {
    color: "#D175B6",
  },
  "& .MuiRating-iconHover": {
    color: "#c064a2",
  },
});

export default function RatingComponent({ value, onChange, size = "medium" }) {
  return (
    <PinkRating
      name="custom-rating"
      value={value}
      onChange={onChange}
      precision={0.5}
      size={size}
      emptyIcon={
        <StarBorder
          sx={{
            color: getCssVariableHandler({
              variableName: "--primary-pink-hex",
            }),
          }}
        />
      }
      icon={
        <Star
          sx={{
            color: getCssVariableHandler({
              variableName: "--primary-pink-hex",
            }),
          }}
        />
      }
    />
  );
}

RatingComponent.propTypes = {
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  size: PropTypes.oneOf(["small", "medium", "large"]),
};